const BLANK = '';
const STAGING = 'staging';

export const useDailyStagingEnv = (
    process.env.REACT_APP_PROD_ENDPOINT || BLANK
).includes(STAGING);

export const ROOM_ENDPOINT = `${process.env.REACT_APP_DAILY_JS_ENDPOINT}/rooms`;

export const MEETING_TOKEN_ENDPOINT = `${process.env.REACT_APP_DAILY_JS_ENDPOINT}/meeting-tokens`;

export const ALLOWED_TEST_ENV = ['dev', 'test'];

export const DEFAULT_MAX_TILES_PER_PAGE = 25;

export const MEDIA_STATES = {
    MUTED: 'muted',
    UNMUTED: 'unmuted',
    CHANGING: 'changing',
    BLOCKED: 'blocked',
};

export enum LAYOUT_STATES {
    GRID = 'grid',
    SPEAKER = 'speaker',
}

export const DEFAULT_LAYOUT = LAYOUT_STATES.GRID;

export type GM_MEDIA_STATE = {
    audio: string;
    video: string;
};

export const DEFAULT_AUDIO_VIDEO_STATE: GM_MEDIA_STATE = {
    audio: MEDIA_STATES.MUTED,
    video: MEDIA_STATES.MUTED,
};

export const getTruncatedRoomNameFromUuid = (uuidStr: string = '') =>
    uuidStr.length > 30 ? uuidStr.substr(0, uuidStr.lastIndexOf('-')) : uuidStr;
